import {
  type GenerateStyle,
  type FullToken,
  genComponentStyleHook,
} from "antd/es/theme/internal";
import { tooltipPrefixCls } from "@/base/components/tooltip/Tooltip.component";

const genStyle: GenerateStyle<FullToken<"Tooltip">> = (token: any) => {
  const { borderColor } = token;
  return {
    [`.${tooltipPrefixCls}`]: {
      [`&.${tooltipPrefixCls}-placement-top, &.${tooltipPrefixCls}-placement-topLeft, &.${tooltipPrefixCls}-placement-topRight`]:
        {
          [`> .${tooltipPrefixCls}-arrow`]: {
            bottom: "1px !important",
          },
        },
      [`&.${tooltipPrefixCls}-placement-bottom, &.${tooltipPrefixCls}-placement-bottomLeft, &.${tooltipPrefixCls}-placement-bottomRight`]:
        {
          [`> .${tooltipPrefixCls}-arrow`]: {
            top: "1px !important",
          },
        },
      [`&.${tooltipPrefixCls}-placement-left`]: {
        [`> .${tooltipPrefixCls}-arrow`]: {
          right: "1px !important",
        },
      },
      [`&.${tooltipPrefixCls}-placement-right`]: {
        [`> .${tooltipPrefixCls}-arrow`]: {
          left: "1px !important",
        },
      },
      [`.${tooltipPrefixCls}-inner`]: {
        border: `1px solid ${borderColor}`,
        padding: `4px 8px`,
      },
    },
  };
};

export const useTooltipStyle = genComponentStyleHook(
  ["Tooltip", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
